import { BNButton, BNFooter } from "@bn-monorepo/js-packages";
import Media from "../CmsComponents/Media/Media";
import React, { JSX, useContext } from "react";
import styles from "./styles.module.scss";
import { Link } from "react-router";
import { SettingsContext } from "../../settingsContext";
import { SxProps, Theme } from "@mui/material";
import { Image } from "../CmsDocuments/SectionPage/components/Section/Section";

interface Link {
  name: string;
  url: string;
  udi: string | null;
}

interface Props {
  links?: Array<Link>;
  footerLinksLoggedIn?: Array<Link>;
  address?: string;
  companyName?: string;
  info: string;
  image?: Image;
  loggedIn: boolean;
  isApp: boolean;
  sx?: SxProps<Theme> | undefined;
}

const Footer: React.FC<Props> = (props) => {
  const { image, isApp, sx } = props;
  const { resolveUrl, env } = useContext(SettingsContext);
  const renderLinkCollection = (links: Array<Link> | undefined): JSX.Element[] => {
    const elements: JSX.Element[] = [];
    if (links) {
      links.map((link, i) =>
        elements.push(
          <li key={`footer-menu-${i}`}>
            <BNButton
              href={link.udi != null ? undefined : resolveUrl(link.url)}
              to={link.udi != null ? resolveUrl(link.url) : undefined}
              component={link.udi != null ? Link : undefined}
              variant="text"
              sx={{ px: 0, fontSize: "1.6rem !important" }}
              data-cms-target-key={env !== "prod" ? link.udi : undefined}
            >
              {link.name}
            </BNButton>
          </li>,
        ),
      );
    }
    return elements;
  };
  return (
    <BNFooter
      sx={sx}
      isApp={isApp}
      info={props.info}
      address={props.address}
      companyName={props.companyName}
      imageElement={
        image ? (
          <Media
            imagePath={image.url}
            className={styles.footerImage}
            AltText={image.alt}
            height={image.height}
            width={image.width}
          />
        ) : (
          <></>
        )
      }
    >
      <>{renderLinkCollection(props.loggedIn ? props.footerLinksLoggedIn : props.links)}</>
    </BNFooter>
  );
};
export default Footer;
